module.exports = __webpack_public_path__ + "img/bike_active.514391b9.svg";